import { Zap, Target, Scale, Wind, Clock } from "lucide-react";
import { SESSION_FLOW } from "@/data/site";

const ICONS = { zap: Zap, target: Target, scale: Scale, wind: Wind };

export const SessionScience = () => (
  <section className="relative overflow-hidden bg-[#0B3B38] text-teal-50">
    <div className="pointer-events-none absolute -right-28 top-10 h-96 w-96 rounded-full bg-[#0E9E96]/30 blur-3xl" />
    <div className="relative mx-auto max-w-6xl px-5 py-16 lg:px-8">
      <div className="max-w-2xl">
        <span className="text-xs font-extrabold uppercase tracking-wider text-[#FACC15]">
          The movement science
        </span>
        <h2 className="mt-2 font-head text-3xl font-extrabold tracking-tight text-white sm:text-4xl">
          Every minute is engineered
        </h2>
        <p className="mt-3 text-base text-teal-50/80">
          Our signature 4-stage session flow blends sport, play and neuro-physical science.
        </p>
      </div>

      <div className="mt-10 grid gap-4 md:grid-cols-2">
        {SESSION_FLOW.map((p, i) => {
          const Icon = ICONS[p.icon];
          return (
            <div
              key={i}
              data-testid={`flow-stage-${i}`}
              className="flex gap-4 rounded-3xl border border-teal-800/60 bg-teal-900/40 p-6 transition-colors hover:bg-teal-900/70"
            >
              <span className="grid h-14 w-14 flex-none place-items-center rounded-2xl bg-[#F97316] text-white shadow-lg">
                <Icon className="h-6 w-6" />
              </span>
              <div>
                <div className="flex flex-wrap items-center gap-2">
                  <span className="font-mono text-xs font-extrabold text-[#FACC15]">{p.time}</span>
                  <span className="rounded-full bg-teal-800/70 px-2.5 py-0.5 text-[11px] font-extrabold uppercase tracking-wide text-teal-100">
                    {p.tag}
                  </span>
                </div>
                <h3 className="mt-1 font-head text-lg font-extrabold text-white">{p.name}</h3>
                <p className="mt-1 text-sm text-teal-50/80">{p.desc}</p>
              </div>
            </div>
          );
        })}
      </div>

      <p className="mt-8 flex items-center justify-center gap-2 text-center text-sm font-bold text-teal-100/70">
        <Clock className="h-4 w-4 text-[#FACC15]" /> Full 30–45 minute session • all equipment supplied • WWCC-verified coaches
      </p>
    </div>
  </section>
);
